import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { BannerResponse } from '../models/banner.response';

@Injectable({
  providedIn: 'root',
})
export class BannersApiService {
  apiService = inject(ApiService);

  getBanners(): Observable<BannerResponse> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'dpx/banners/search').enableCache(15 * 1000 * 60);
    return this.apiService.call(request);
  }
}
